module.exports = __webpack_public_path__ + "static/media/go_back_icon.6e1e2a1c.svg";